import React, { useState, useRef, useEffect } from 'react';
import './AccountMenu.css';

const AccountMenu = ({ user, handleLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="account-menu" ref={menuRef}>
      <button onClick={toggleMenu} className="account-button">
        <img src="/icons/account.png" alt="Account" className="account-icon" />
      </button>
      {isOpen && (
        <div className="dropdown-menu">
          <div className="dropdown-header">
            {user && <p>{user.email}</p>}
          </div>
          <ul>
            <li><a href="/account">My Account</a></li>
            <li><a href="/support">Customer Support</a></li>
            <li><button onClick={handleLogout} className="sign-out-button-menu">Sign out</button></li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default AccountMenu;
